<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
    >
        <path
            d="M8.88889 10.2778C8.88889 9.66556 9.38777 9.16667 10 9.16667C10.6122 9.16667 11.1111 9.66556 11.1111 10.2778C11.1111 10.89 10.6122 11.3889 10 11.3889C9.38777 11.3889 8.88889 10.89 8.88889 10.2778Z"
            fill="currentColor"
        />
        <path
            d="M13.8889 11.3889C14.5011 11.3889 15 10.89 15 10.2778C15 9.66556 14.5011 9.16667 13.8889 9.16667C13.2767 9.16667 12.7778 9.66556 12.7778 10.2778C12.7778 10.89 13.2767 11.3889 13.8889 11.3889Z"
            fill="currentColor"
        />
        <path
            d="M8.88889 13.6111C8.88889 12.9989 9.38777 12.5 10 12.5C10.6122 12.5 11.1111 12.9989 11.1111 13.6111C11.1111 14.2233 10.6122 14.7222 10 14.7222C9.38777 14.7222 8.88889 14.2233 8.88889 13.6111Z"
            fill="currentColor"
        />
        <path
            d="M6.11111 12.5C5.49889 12.5 5 12.9989 5 13.6111C5 14.2233 5.49889 14.7222 6.11111 14.7222C6.72333 14.7222 7.22222 14.2233 7.22222 13.6111C7.22222 12.9989 6.72333 12.5 6.11111 12.5Z"
            fill="currentColor"
        />
        <path
            d="M12.7778 13.6111C12.7778 12.9989 13.2767 12.5 13.8889 12.5C14.5011 12.5 15 12.9989 15 13.6111C15 14.2233 14.5011 14.7222 13.8889 14.7222C13.2767 14.7222 12.7778 14.2233 12.7778 13.6111Z"
            fill="currentColor"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M6.38889 0.0833282C6.8031 0.0833282 7.13889 0.419115 7.13889 0.833328V2.30556H12.8611V0.833328C12.8611 0.419115 13.1969 0.0833282 13.6111 0.0833282C14.0253 0.0833282 14.3611 0.419115 14.3611 0.833328V2.30556H15.2778C16.9193 2.30556 18.25 3.63627 18.25 5.27778V14.7222C18.25 16.3637 16.9193 17.6944 15.2778 17.6944H4.72222C3.08071 17.6944 1.75 16.3637 1.75 14.7222V5.27778C1.75 3.63627 3.08071 2.30556 4.72222 2.30556H5.63889V0.833328C5.63889 0.419115 5.97467 0.0833282 6.38889 0.0833282ZM16.75 5.27778V6.19444H3.25V5.27778C3.25 4.46469 3.90914 3.80556 4.72222 3.80556H15.2778C16.0909 3.80556 16.75 4.46469 16.75 5.27778ZM16.75 7.69444H3.25V14.7222C3.25 15.5353 3.90914 16.1944 4.72222 16.1944H15.2778C16.0909 16.1944 16.75 15.5353 16.75 14.7222V7.69444Z"
            fill="currentColor"
        />
    </svg>
</template>
